import React from 'react';
import Image from 'next/image';
import StudyBanner from '@/assets/banners/studying.png';

const BlogBanner = ({ handleOpen }: any) => {
  return (
    <section className="my-10 w-full">
      <div className="flex w-full items-center justify-between rounded-2xl bg-gradient-to-r from-orange-100 to-purple-100 p-4 md:px-8">
        <div>
          <h2 className="text-lg font-bold text-tertiary sm:text-xl">Are you Confused? Talk to Our Expert</h2>
          <p className="mt-2 text-sm text-gray-500 sm:text-base">
            Our expert offers personalized guidance and mentorship for your academic and career goals
          </p>
          <button
            onClick={handleOpen}
            className="mt-4 rounded-lg bg-secondary-blue px-6 py-2 text-sm font-semibold text-white transition hover:bg-blue-700 sm:text-base"
          >
            Connect Now
          </button>
        </div>
        <div className="hidden sm:block">
          <Image src={StudyBanner} alt="Question Mark Illustration" className="size-32" width={128} height={60} />
        </div>
      </div>
    </section>
  );
};

export default BlogBanner;
